export const truncateString = (str, length) => {
  if (typeof str !== 'string' || typeof length !== 'number' || length < 1) {
    throw new Error('truncateString function: Invalid Parameter')
  }
  return str.length > length ? str.slice(0, length) + '...' : str
}
